import { icon as cacheRush } from './img/cache-rush';
import { icon as grandExpressFiesta } from './img/de-sweet-love'; /* './img/de-sweet-love.svg'; */
import { icon as diamondExplosion } from './img/diamond-explosion-7s';
import { icon as buffalo } from './img/iw-buffalo';
import { icon as diamonds } from './img/iw-diamonds';
import { icon as mayanCache } from './img/mayan-cache';
import { icon as princeOfRiches } from './img/prince-of-riches';
import { icon as trueWild } from './img/true-wild';
import { icon as vegasRepeatWins } from './img/vegas-repeat-wins';

export const animatedIcons: {
  [key: string]: string;
} = {
  rp_81: cacheRush, // Cache Rush
  rp_89: grandExpressFiesta, // Grand Express Fiesta
  rp_72: diamondExplosion, // Diamond Explosion 7s
  rp_93: buffalo, // buffalo
  rp_88: diamonds, // Immortal Ways Diamonds
  rp_32: mayanCache, // Mayan Cache
  rp_85: princeOfRiches, // Prince of Riches
  rp_87: trueWild, // True Wild
  rp_84: vegasRepeatWins, // Vegas Repeat Wins
};
